import Confirm from './Confirm';
import './Confirm.scss';

export default Confirm;
